export default async (limit = 3) => {
  // http://localhost:3000/api/audios?page=2&limit=3
  const url = limit ? `/api/audios?limit=${limit}` : "/api/audios";
  const { data, error } = await useFetch(url, {
    headers: useRequestHeaders(["cookie"])
  });

  if (error.value) {
    throw createError({
      ...error.value,
      statusMessage: "Unable to fetch audio"
    });
  }
  return { data };
};
